import LayoutComponent from "../components/LayoutComponent";

export default function HomePage() {

    return (
        <LayoutComponent links={
            [
                {
                    title: 'Panel',
                    url: '/'
                },

            ]}
        >
            <p style={{fontSize: '40px', fontWeight: 'bold', marginBottom: '0'}}>TEKNODX</p>
            <span>Yönetim Paneli</span>
        </LayoutComponent>
    )
}
